import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Badminton = () => {
  return (
    <SportsLayoutComp name={'Badminton'}/>
  )
}

export default Badminton